import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import { GetChangeStatus, GetTenderList, DeleteTender, CreateTender, GetTenderDetail, GetEditTender } from '../../../services/company_panel/setting/tenderConfigurationService';
import Swal from 'sweetalert2'
import CustomPagination from '../../../components/company_panel/common/custompagination'
import Sorting from '../../../components/company_panel/common/sorting';
import Loader from '../../../components/company_panel/common/loader'
import $ from "jquery";
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getCompany, removeHyphens, removeModalBackdrops } from '../../../helpers/commonFunctions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationTab from '../configurationTab';
import * as yup from 'yup';
import { ChangeAddOnCategoryStatus, ChangeStatusAddOn, CreateAddOnCategory, DeleteAddOn, DeleteAddOnCategory, editAddOnCategory, ExportAddOnRecipes, ExportAddOnsPricing, ExportAllAddOns, GetAddOnCategoryList, ImportAddOnRecipes, ImportAddOns, ImportAddOnsPricing, GetAllAddOnCategory, GetSingleAddOnCategory, ListAddOn } from '../../../services/company_panel/menuAddOnCategory';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import CustomRangepicker from '../../../components/company_panel/common/rangepicker';
import { showFilterlist } from '../../../utils/Constants';
import StatusFilter from '../../../components/company_panel/common/statusFilter';
import notFound from '../../../assets/company/img/no-record-found.png'
import { usePersistedListState } from '../../../hooks/usePersistedListState';


const AddOnsList = () => {
    const navigate = useNavigate()
    // persisted filters (page lives in the route/query) — restored on return from add/edit/view
    const { saved, save, clear } = usePersistedListState('add_ons');
    const [submitted, setSubmitted] = useState(false)
    const location = useLocation()
    const routeParams = useParams()
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(routeParams?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [tenderType, setTenderType] = useState(saved?.tenderType || 'AddOns')
    const [name, setName] = useState('Name')
    const [showDefault, setShowDefault] = useState({})
    const [actionType, setActionType] = useState('add');
    const [catId, setCatId] = useState(null)
    const [orderMode, setOrderMode] = useState([]);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [addOnCategories, setAddOnCategories] = useState([]);
    const [exporting, setExporting] = useState(false);
    const [importing, setImporting] = useState(false);
    const [exportingRecipes, setExportingRecipes] = useState(false);
    const [importingRecipes, setImportingRecipes] = useState(false);
    const [exportingPricing, setExportingPricing] = useState(false);
    const [importingPricing, setImportingPricing] = useState(false);



    const handleChangeOrderMode = (selected) => {
        formik.setFieldValue("orderMode", selected);
    };

    useEffect(() => {
        return () => {
            removeModalBackdrops();
        }
    }, []);



    useEffect(() => {
        if (tenderType === 'Category') {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", page);
                formData.append("per_page", itemPerPage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalSearch);
                formData.append('tender_type', tenderType);
                formData.append('company_id', getCompany().company_id);
                formData.append('brand_id', getBrandId());
                GetAddOnCategoryList(formData)
                    .then(data => {
                        setDataLength(data.data.response.count);
                        setList(data && data.data && data.data.response ? data.data.response.rows : []);
                        setLoader(false);
                    })
                    .catch(error => {
                        console.log("error ====> ", error);
                    });
            }
            generateSKU();
        }
    }, [location, statsUpdate, sorting, search, globalSearch, tenderType, isBrandChanged]);

    useEffect(() => {

        if (tenderType === 'AddOns') {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", page);
                formData.append("per_page", itemPerPage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalSearch);
                formData.append('tender_type', tenderType);

                formData.append('brand_id', getBrandId());
                ListAddOn(formData)
                    .then(data => {
                        setDataLength(data.data.response.count);
                        setList(data && data.data && data.data.response ? data.data.response.rows : []);
                        setLoader(false);
                    })
                    .catch(error => {
                        console.log("error ====> ", error);
                    });
            }
            generateSKU();
        }
    }, [location, statsUpdate, sorting, search, globalSearch, tenderType, isBrandChanged]);



    useEffect(() => {
        const formData = new FormData();
        formData.append('brand_id', getBrandId());
        GetAllAddOnCategory(formData).then(data => {
            setAddOnCategories(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("addon categories error ====> ", error);
        })
    }, [isBrandChanged])

    // persist filters on every change (page lives in the route/query, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch, tenderType });
    }, [itemPerPage, sorting, search, globalSearch, tenderType])

    // ---- Export add-on recipes ------------------------------------------------
    // The template comes back filled with the recipes of the add-ons on screen
    // (same filters as the list), plus a sheet of the brand's order mode short
    // codes to read off while editing — laid out like the menu item recipes file.
    // Shared by the export and the import, so a file exported here always passes
    // the import's header check and can be edited and uploaded straight back.
    const RECIPE_COLUMNS = [
        { field: 'add_on_id', label: 'add-on id', header: 'Add-On ID' },
        { field: 'recipe_sku', label: 'recipe sku', header: 'Recipe SKU' },
        { field: 'quantity', label: 'quantity', header: 'Quantity' },
        { field: 'order_mode_short_codes', label: 'order mode short code', header: 'Order Mode Short Code' },
    ];

    const downloadAddOnRecipes = () => {
        if (exportingRecipes) return;
        const buildWorkbook = async (recipeList, orderModes) => {
            const recipeRows = recipeList.map(recipe => ([
                recipe?.add_on_id ?? '',
                recipe?.recipe_sku || '',
                // A real number so the column can be edited as a quantity.
                isNaN(Number(recipe?.quantity)) ? recipe?.quantity : Number(recipe?.quantity),
                (recipe?.order_mode_short_codes || []).join(', '),
            ]));
            const workbook = new ExcelJS.Workbook();
            const recipesSheet = workbook.addWorksheet('Recipes');
            recipesSheet.columns = RECIPE_COLUMNS.map((column, index) => ({ header: column.header, width: [14, 22, 12, 60][index] }));
            // Nothing to edit yet: show the example row so the format is still clear.
            recipesSheet.addRows(recipeRows.length ? recipeRows : [[1, 'QKV503BS', 2, 'DNIN, TKOUT']]);
            recipesSheet.getRow(1).font = { bold: true };
            // only quantity and the short codes are typed in; the id and sku say which recipe line a row is
            [3, 4].forEach(columnNumber => recipesSheet.getColumn(columnNumber).eachCell((cell, rowNumber) => {
                if (rowNumber > 1) cell.protection = { locked: false };
            }));
            await recipesSheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });

            // Second sheet so whoever fills the template can read the brand's
            // short codes straight off it instead of hunting for them. Read only.
            const codesSheet = workbook.addWorksheet('order-mode-short-codes');
            codesSheet.columns = [{ header: 'Order Mode Name', width: 30 }, { header: 'Short Code', width: 18 }];
            codesSheet.addRows(orderModes.map(orderMode => ([
                orderMode?.name ? capitalizeFirstLetter(orderMode.name) : '-',
                orderMode?.short_code || '-',
            ])));
            codesSheet.getRow(1).font = { bold: true };
            await codesSheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });

            const excelBuffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'update-add-on-bulk-recipes-sample.xlsx');
        };

        setExportingRecipes(true);
        ExportAddOnRecipes({
            brand_id: getBrandId(),
            sort: JSON.stringify(sorting),
            search: JSON.stringify(search),
            global_search: globalSearch,
        }).then(data => {
            const response = data?.data?.response || {};
            return buildWorkbook(response.recipe_list || [], response.order_modes || []);
        }).catch(error => {
            console.log("Error---->", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Could not export add-on recipes',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }).finally(() => {
            setExportingRecipes(false);
        });
    };

    // ---- Import add-on recipes ------------------------------------------------
    // The exported sheet, edited and uploaded back. Rows are checked against the
    // same rules the API enforces, so a bad row is reported by its sheet row
    // number here instead of failing the whole request on the server. Rows are
    // never skipped: the import also removes recipe lines, so a dropped row
    // could delete that line.
    const recipeFileInputRef = useRef(null);

    const triggerRecipeFileInput = () => {
        if (importingRecipes) return;
        if (recipeFileInputRef.current) {
            recipeFileInputRef.current.click();
        }
    };

    const handleAddOnRecipeFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let headers = [];
            let sheetRows = [];
            try {
                const workbook = XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                // Header row first, so the columns are checked before any row is read.
                const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false });
                headers = raw[0] || [];
                sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });
            } catch (error) {
                console.log("Error---->", error);
                showAddOnImportError('This file could not be read. Please upload a valid xls or xlsx file.');
                return;
            }

            const headerMap = {};
            const missing = [];
            RECIPE_COLUMNS.forEach(column => {
                const match = headers.find(header => normalizeHeader(header) === column.label);
                if (match === undefined) missing.push(column.header);
                else headerMap[column.field] = match;
            });
            if (missing.length) {
                showAddOnImportError(`These column(s) are missing: <b>${missing.join(', ')}</b>`);
                return;
            }
            if (!sheetRows.length) {
                showAddOnImportError('This file has no rows to import.');
                return;
            }

            const errors = [];
            const recipes = [];
            sheetRows.forEach((sheetRow, index) => {
                // +2: the header is row 1, so the first data row is row 2 in the sheet.
                const rowNumber = index + 2;
                const cell = (field) => String(sheetRow[headerMap[field]] ?? '').trim();

                const addOnId = cell('add_on_id');
                const recipeSku = cell('recipe_sku');
                const quantity = cell('quantity');
                // Short codes on the order mode, comma separated in one cell.
                const orderModeShortCodes = cell('order_mode_short_codes').split(',').map(code => code.trim()).filter(Boolean);

                if (!addOnId || !Number.isInteger(Number(addOnId)) || Number(addOnId) <= 0) errors.push(`Row ${rowNumber}: add-on id must be a whole number greater than 0`);
                if (!recipeSku) errors.push(`Row ${rowNumber}: recipe sku is required`);
                if (!quantity || !Number.isFinite(Number(quantity)) || Number(quantity) <= 0) errors.push(`Row ${rowNumber}: quantity must be a number greater than 0`);
                if (!orderModeShortCodes.length) errors.push(`Row ${rowNumber}: at least one order mode short code is required`);

                recipes.push({
                    add_on_id: Number(addOnId),
                    recipe_sku: recipeSku,
                    quantity: Number(quantity),
                    order_mode_short_codes: orderModeShortCodes,
                });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showAddOnImportError(`${shown}${more}`);
                return;
            }

            setImportingRecipes(true);
            ImportAddOnRecipes({
                brand_id: getBrandId(),
                recipes: JSON.stringify(recipes),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Could not import add-on recipes',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setImportingRecipes(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    // ---- Export add-on pricing -----------------------------------------------
    // One workbook, one tab per kind of price: the add-on's own price, its
    // default prices and its outlet specific prices. Prices are written as real
    // numbers so the sheet can be edited or summed.
    const downloadAddOnsPricing = () => {
        if (exportingPricing) return;
        setExportingPricing(true);
        const formData = new FormData();
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalSearch);
        formData.append('brand_id', getBrandId());
        ExportAddOnsPricing(formData).then(async data => {
            const rows = data?.data?.response?.rows || data?.data?.data?.rows || [];
            if (!rows.length) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: 'There are no add-on prices to export',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                });
                return;
            }

            const toPrice = (value) => (value == null || value === '' ? 'N/A' : (isNaN(Number(value)) ? value : Number(value)));

            const pricesData = [];
            const defaultPricesData = [];
            const specificPricesData = [];

            rows.forEach(addOn => {
                const addOnId = addOn?.id ?? 'N/A';
                const addOnName = addOn?.name ? capitalizeFirstLetter(addOn.name) : 'N/A';

                pricesData.push({
                    'Add-On ID': addOnId,
                    'Add-On Name': addOnName,
                    'Price': toPrice(addOn?.price),
                });

                (addOn?.add_on_outlet_default_prices || []).forEach(price => defaultPricesData.push({
                    'Add-On ID': addOnId,
                    'Add-On Name': addOnName,
                    'Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator ID': price?.order_mode_id ?? price?.aggregator_id ?? '',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': toPrice(price?.price),
                }));

                (addOn?.add_on_outlet_specific_prices || []).forEach(price => specificPricesData.push({
                    'Add-On ID': addOnId,
                    'Add-On Name': addOnName,
                    'Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator ID': price?.order_mode_id ?? price?.aggregator_id ?? '',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': toPrice(price?.price),
                    'Outlet Short Codes': (price?.outlets || []).map(outlet => outlet?.short_code).filter(Boolean).join(', ') || 'N/A',
                }));

            });

            // Column widths from header + content, clamped.
            const autoCols = (sheetRows, headers) => headers.map(key => {
                let max = String(key).length;
                sheetRows.forEach(row => {
                    const length = row[key] == null ? 0 : String(row[key]).length;
                    if (length > max) max = length;
                });
                return { wch: Math.min(Math.max(max + 2, 10), 60) };
            });

            const sheets = [
                { name: 'Prices', rows: pricesData, header: ['Add-On ID', 'Add-On Name', 'Price'] },
                { name: 'Default Prices', rows: defaultPricesData, header: ['Add-On ID', 'Add-On Name', 'Type', 'Order Mode / Aggregator ID', 'Order Mode / Aggregator Name', 'Price'] },
                { name: 'Specific Prices', rows: specificPricesData, header: ['Add-On ID', 'Add-On Name', 'Type', 'Order Mode / Aggregator ID', 'Order Mode / Aggregator Name', 'Price', 'Outlet Short Codes'] },
            ];
            // ExcelJS so the price cells can be left editable while the rest of each sheet is locked
            const workbook = new ExcelJS.Workbook();
            for (const sheet of sheets) {
                const widths = autoCols(sheet.rows, sheet.header);
                const worksheet = workbook.addWorksheet(sheet.name);
                worksheet.columns = sheet.header.map((header, index) => ({ header, key: header, width: widths[index].wch }));
                worksheet.addRows(sheet.rows);
                worksheet.getRow(1).font = { bold: true };
                worksheet.getColumn('Price').eachCell((cell, rowNumber) => {
                    if (rowNumber > 1) cell.protection = { locked: false };
                });
                // sorting, filtering and resizing stay allowed; only the cell values are protected
                await worksheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });
            }
            const excelBuffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'add-ons-pricing.xlsx');
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Could not export add-on pricing',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }).finally(() => {
            setExportingPricing(false);
        });
    };

    // ---- Import add-on pricing ------------------------------------------------
    // The pricing sheet, edited and uploaded back. Each tab is read by its name and
    // sent as its own array: prices of { id, price }; default and specific prices of
    // { id, aggregator_id, order_mode_id, price }, specific prices also carrying
    // outlet_short_codes [] from the comma separated Outlet Short Codes column. Type
    // decides whether the id column is an order mode or an aggregator.
    const PRICING_SHEETS = [
        {
            key: 'prices',
            name: 'Prices',
            columns: [
                { field: 'add_on_id', label: 'add-on id', header: 'Add-On ID' },
                { field: 'price', label: 'price', header: 'Price' },
            ],
        },
        {
            key: 'default_prices',
            name: 'Default Prices',
            columns: [
                { field: 'add_on_id', label: 'add-on id', header: 'Add-On ID' },
                { field: 'type', label: 'type', header: 'Type' },
                { field: 'price_id', label: 'order mode / aggregator id', header: 'Order Mode / Aggregator ID' },
                { field: 'price', label: 'price', header: 'Price' },
            ],
        },
        {
            key: 'specific_prices',
            name: 'Specific Prices',
            columns: [
                { field: 'add_on_id', label: 'add-on id', header: 'Add-On ID' },
                { field: 'type', label: 'type', header: 'Type' },
                { field: 'price_id', label: 'order mode / aggregator id', header: 'Order Mode / Aggregator ID' },
                { field: 'price', label: 'price', header: 'Price' },
                { field: 'outlet_short_codes', label: 'outlet short codes', header: 'Outlet Short Codes' },
            ],
        },
    ];
    const pricingFileInputRef = useRef(null);

    const triggerPricingFileInput = () => {
        if (importingPricing) return;
        if (pricingFileInputRef.current) {
            pricingFileInputRef.current.click();
        }
    };

    const handleAddOnPricingFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let workbook;
            try {
                workbook = XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
            } catch (error) {
                console.log("Error---->", error);
                showAddOnImportError('This file could not be read. Please upload a valid xls or xlsx file.');
                return;
            }

            const missingSheets = PRICING_SHEETS.filter(pricingSheet => !workbook.Sheets[pricingSheet.name]).map(pricingSheet => pricingSheet.name);
            if (missingSheets.length) {
                showAddOnImportError(`These sheet(s) are missing: <b>${missingSheets.join(', ')}</b>`);
                return;
            }

            const errors = [];
            const pricing = {};
            PRICING_SHEETS.forEach(pricingSheet => {
                const sheet = workbook.Sheets[pricingSheet.name];
                // Header row first, so the columns are checked before any row is read.
                const headers = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false })[0] || [];
                const sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });

                const headerMap = {};
                const missing = [];
                pricingSheet.columns.forEach(column => {
                    const match = headers.find(header => normalizeHeader(header) === column.label);
                    if (match === undefined) missing.push(column.header);
                    else headerMap[column.field] = match;
                });
                pricing[pricingSheet.key] = [];
                if (missing.length) {
                    errors.push(`${pricingSheet.name}: these column(s) are missing: <b>${missing.join(', ')}</b>`);
                    return;
                }

                sheetRows.forEach((sheetRow, index) => {
                    // +2: the header is row 1, so the first data row is row 2 in the sheet.
                    const row = `${pricingSheet.name} row ${index + 2}`;
                    const cell = (field) => String(sheetRow[headerMap[field]] ?? '').trim();

                    const addOnId = cell('add_on_id');
                    // the sample file writes N/A where a price isn't set
                    const price = cell('price').toLowerCase() === 'n/a' ? '' : cell('price');
                    if (!addOnId || !Number.isInteger(Number(addOnId)) || Number(addOnId) <= 0) errors.push(`${row}: add-on id must be a whole number greater than 0`);
                    if (price && (!Number.isFinite(Number(price)) || Number(price) < 0)) errors.push(`${row}: price must be a number of 0 or more`);

                    if (pricingSheet.key === 'prices') {
                        pricing.prices.push({ id: Number(addOnId), price: price === '' ? '' : Number(price) });
                        return;
                    }

                    const type = normalizeHeader(cell('type'));
                    const priceId = cell('price_id');
                    if (type !== 'order mode' && type !== 'aggregator') errors.push(`${row}: type must be Order Mode or Aggregator`);
                    if (!priceId || !Number.isInteger(Number(priceId)) || Number(priceId) <= 0) errors.push(`${row}: order mode / aggregator id must be a whole number greater than 0`);

                    pricing[pricingSheet.key].push({
                        id: Number(addOnId),
                        aggregator_id: type === 'aggregator' ? Number(priceId) : null,
                        order_mode_id: type === 'order mode' ? Number(priceId) : null,
                        // the sample file writes N/A where a group has no outlets
                        ...(pricingSheet.key === 'specific_prices' && {
                            outlet_short_codes: cell('outlet_short_codes').toLowerCase() === 'n/a' ? [] : [...new Set(cell('outlet_short_codes').split(',').map(code => code.trim()).filter(Boolean))],
                        }),
                        price: price === '' ? '' : Number(price),
                    });
                });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showAddOnImportError(`${shown}${more}`);
                return;
            }
            if (!pricing.prices.length && !pricing.default_prices.length && !pricing.specific_prices.length) {
                showAddOnImportError('This file has no rows to import.');
                return;
            }

            setImportingPricing(true);
            ImportAddOnsPricing({
                brand_id: getBrandId(),
                prices: JSON.stringify(pricing.prices),
                default_prices: JSON.stringify(pricing.default_prices),
                specific_prices: JSON.stringify(pricing.specific_prices),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Could not import add-on pricing',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setImportingPricing(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    // ---- Import add-ons -----------------------------------------------------
    // The sheet is read here and only its rows go to the API. One definition
    // drives the sample files, the header check and the row mapping, so the
    // three can never disagree about which columns exist.
    const ADDON_COLUMNS = [
        { field: 'name', label: 'name', header: 'Name', sample: 'Extra Cheese', width: 24 },
        { field: 'category_skus', label: 'category skus', header: 'Category SKUs', sample: 'TOPPINGS, DAIRY', width: 30 },
        { field: 'default_price', label: 'default price', header: 'Default Price', sample: 3, width: 14 },
        { field: 'short_description', label: 'short description', header: 'Short Description', sample: 'Melted cheddar on top', width: 32 },
        { field: 'pricing_type', label: 'pricing type', header: 'Pricing Type', sample: 'fixed', width: 16 },
    ];

    // The two pricing types the add-on form offers.
    const PRICING_TYPES = ['fixed', 'ask_for_price'];

    // Case and spacing aside, the header has to read exactly like the column:
    // "Default Price" and "default price" pass, "default_price" does not.
    const normalizeHeader = (header) => String(header || '').trim().toLowerCase().replace(/\s+/g, ' ');

    const downloadAddOnSample = (bookType, extension) => {
        const ws = XLSX.utils.aoa_to_sheet([
            ADDON_COLUMNS.map(column => column.header),
            ADDON_COLUMNS.map(column => column.sample),
        ]);
        ws['!cols'] = ADDON_COLUMNS.map(column => ({ wch: column.width }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Add Ons');
        const buffer = XLSX.write(wb, { bookType, type: 'array' });
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `add-ons-sample.${extension}`);
    };

    const addOnFileInputRef = useRef(null);

    const triggerAddOnFileInput = () => {
        if (importing) return;
        if (addOnFileInputRef.current) {
            addOnFileInputRef.current.click();
        }
    };

    const showAddOnImportError = (html) => {
        Swal.fire({
            customClass: 'swal-wide',
            icon: 'error',
            title: 'Invalid file',
            html,
            confirmButtonColor: '#2f9bff',
        });
    };

    const handleAddOnFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let headers = [];
            let sheetRows = [];
            try {
                // A CSV is text, so decode it as UTF-8 first: handed over as raw bytes,
                // SheetJS reads a UTF-8 file without a BOM as Latin-1 and garbles any
                // accented text. xls / xlsx store Unicode themselves and are read as bytes.
                const isCsv = /\.csv$/i.test(file.name);
                const workbook = isCsv
                    ? XLSX.read(new TextDecoder('utf-8').decode(event.target.result), { type: 'string' })
                    : XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                // Header row first, so the columns are checked before any row is read.
                const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false });
                headers = raw[0] || [];
                sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });
            } catch (error) {
                console.log("Error---->", error);
                showAddOnImportError('This file could not be read. Please upload a valid csv, xls or xlsx file.');
                return;
            }

            const headerMap = {};
            const missing = [];
            ADDON_COLUMNS.forEach(column => {
                const match = headers.find(header => normalizeHeader(header) === column.label);
                if (match === undefined) missing.push(column.header);
                else headerMap[column.field] = match;
            });
            if (missing.length) {
                showAddOnImportError(`These column(s) are missing: <b>${missing.join(', ')}</b>`);
                return;
            }
            if (!sheetRows.length) {
                showAddOnImportError('This file has no rows to import.');
                return;
            }

            const errors = [];
            const addOns = [];
            sheetRows.forEach((sheetRow, index) => {
                // +2: the header is row 1, so the first data row is row 2 in the sheet.
                const rowNumber = index + 2;
                const cell = (field) => String(sheetRow[headerMap[field]] ?? '').trim();

                const name = cell('name');
                const categorySkus = cell('category_skus').split(',').map(sku => sku.trim()).filter(Boolean);
                const defaultPrice = cell('default_price');
                const shortDescription = cell('short_description');
                // "Ask for price" and "ask-for-price" both mean ask_for_price; blank
                // falls back to fixed, as the add-on form does.
                const pricingType = cell('pricing_type').toLowerCase().replace(/[\s-]+/g, '_') || 'fixed';

                // The same rules the create add-on form enforces.
                if (!name) errors.push(`Row ${rowNumber}: name is required`);
                else if (name.length > 60) errors.push(`Row ${rowNumber}: name should not exceed 60 characters`);
                if (!categorySkus.length) errors.push(`Row ${rowNumber}: at least one category sku is required`);
                if (defaultPrice === '' || isNaN(Number(defaultPrice))) errors.push(`Row ${rowNumber}: default price must be a number`);
                else if (Number(defaultPrice) < 0) errors.push(`Row ${rowNumber}: default price cannot be negative`);
                else if (!Number.isInteger(Number(defaultPrice))) errors.push(`Row ${rowNumber}: default price must be a whole number`);
                if (shortDescription.length > 250) errors.push(`Row ${rowNumber}: short description cannot exceed 250 characters`);
                if (!PRICING_TYPES.includes(pricingType)) errors.push(`Row ${rowNumber}: pricing type must be fixed or ask_for_price`);

                addOns.push({
                    name,
                    category_skus: categorySkus,
                    default_price: Number(defaultPrice),
                    short_description: shortDescription,
                    pricing_type: pricingType,
                });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showAddOnImportError(`${shown}${more}`);
                return;
            }

            setImporting(true);
            ImportAddOns({
                brand_id: getBrandId(),
                add_ons: JSON.stringify(addOns),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Could not import add-ons',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setImporting(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    // Every add-on the current filters match, from the export endpoint, laid
    // out like the menu items export: the add-ons themselves, then their
    // default and outlet-specific prices on sheets of their own.
    const handleExport = () => {
        if (exporting) return;
        setExporting(true);
        const formData = new FormData();
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalSearch);
        formData.append('brand_id', getBrandId());
        ExportAllAddOns(formData).then(data => {
            const rows = data?.data?.response?.rows || data?.data?.data?.rows || [];
            if (!rows.length) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: 'There are no add-ons to export',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                });
                return;
            }

            const formatPrice = (price) => (price != null && price !== '' ? `${price} SAR` : 'N/A');
            const formatSlug = (value) => (value ? capitalizeFirstLetter(removeHyphens(value)) : 'N/A');

            const addOnsData = [];
            const defaultPricesData = [];
            const specificPricesData = [];

            rows.forEach(addOn => {
                const addOnName = addOn?.name ? capitalizeFirstLetter(addOn.name) : 'N/A';
                addOnsData.push({
                    'Id': addOn?.id ?? 'N/A',
                    'Name': addOnName,
                    'Name (Arabic)': addOn?.name_ar || 'N/A',
                    'Add-On Categories': (addOn?.add_on_categories || [])
                        .map(category => category?.name).filter(Boolean)
                        .map(name => capitalizeFirstLetter(name)).join(', ') || 'N/A',
                    'Price': formatPrice(addOn?.price),
                    'Pricing Type': formatSlug(addOn?.pricing_type),
                    'Tax Group': addOn?.tax_configuration?.name ? capitalizeFirstLetter(addOn.tax_configuration.name) : 'N/A',
                    'Display Rank': addOn?.display_rank ?? 'N/A',
                    'Short Description': addOn?.short_description || 'N/A',
                    'Short Description (Arabic)': addOn?.short_description_ar || 'N/A',
                    'Status': addOn?.status ? 'Active' : 'Inactive',
                    'Created At': addOn?.created_at ? formateDate(addOn.created_at) : 'N/A',
                });

                (addOn?.add_on_outlet_default_prices || []).forEach(price => defaultPricesData.push({
                    'Add-On Id': addOn?.id ?? 'N/A',
                    'Add-On Name': addOnName,
                    'Price Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': formatPrice(price?.price),
                }));

                (addOn?.add_on_outlet_specific_prices || []).forEach(price => specificPricesData.push({
                    'Add-On Id': addOn?.id ?? 'N/A',
                    'Add-On Name': addOnName,
                    'Price Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': formatPrice(price?.price),
                    'Outlets': (price?.outlets || [])
                        .map(outlet => `${outlet?.name || ''}${outlet?.short_code ? ` (${outlet.short_code})` : ''}`.trim())
                        .filter(Boolean).join(', ') || 'N/A',
                }));
            });

            // Column widths from header + content, clamped, as the menu items export does.
            const autoCols = (sheetRows, headers) => headers.map(key => {
                let max = String(key).length;
                sheetRows.forEach(row => {
                    const length = row[key] == null ? 0 : String(row[key]).length;
                    if (length > max) max = length;
                });
                return { wch: Math.min(Math.max(max + 2, 10), 60) };
            });

            const addOnsHeader = ['Id', 'Name', 'Name (Arabic)', 'Add-On Categories', 'Price', 'Pricing Type', 'Tax Group', 'Display Rank', 'Short Description', 'Short Description (Arabic)', 'Status', 'Created At'];
            const defaultPricesHeader = ['Add-On Id', 'Add-On Name', 'Price Type', 'Order Mode / Aggregator Name', 'Price'];
            const specificPricesHeader = ['Add-On Id', 'Add-On Name', 'Price Type', 'Order Mode / Aggregator Name', 'Price', 'Outlets'];

            const addOnsSheet = XLSX.utils.json_to_sheet(addOnsData, { header: addOnsHeader });
            addOnsSheet['!cols'] = autoCols(addOnsData, addOnsHeader);
            const defaultPricesSheet = XLSX.utils.json_to_sheet(defaultPricesData, { header: defaultPricesHeader });
            defaultPricesSheet['!cols'] = autoCols(defaultPricesData, defaultPricesHeader);
            const specificPricesSheet = XLSX.utils.json_to_sheet(specificPricesData, { header: specificPricesHeader });
            specificPricesSheet['!cols'] = autoCols(specificPricesData, specificPricesHeader);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, addOnsSheet, 'Add Ons');
            XLSX.utils.book_append_sheet(wb, defaultPricesSheet, 'Default Outlet Prices');
            XLSX.utils.book_append_sheet(wb, specificPricesSheet, 'Specific Outlet Prices');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'add-ons.xlsx');
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.message || 'Could not export add-ons',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }).finally(() => {
            setExporting(false);
        });
    };

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        // prepareSearch()
        setResetDate(!resetdate)
        $("#defaultstatus").prop("selectedIndex", 0)
        clear()
    }

    // Delete functionality
    function deleteFunction(row) {
        if (tenderType === 'Category') {
            Swal.fire({
                customClass: 'swal-wide',
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2f9bff',
                cancelButtonColor: '#dc3545',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    const formdata = new FormData();
                    formdata.append("id", row);
                    DeleteAddOnCategory(formdata).then(data => {
                        if (data.status === 200) {
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: 'success',
                                title: data.data.message,
                                showConfirmButton: false,
                                timer: 2000,
                                toast: true,
                                position: 'top-right',
                            });
                            setStatusUpdate(!statsUpdate);
                        }
                    }).catch(error => {
                        console.log("deleteError", error);
                    });
                }
            });
        }
        if (tenderType === 'AddOns') {
            Swal.fire({
                customClass: 'swal-wide',
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2f9bff',
                cancelButtonColor: '#dc3545',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    const formdata = new FormData();
                    formdata.append("id", row);
                    DeleteAddOn(formdata).then(data => {
                        if (data.status === 200) {
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: 'success',
                                title: data.data.message,
                                showConfirmButton: false,
                                timer: 2000,
                                toast: true,
                                position: 'top-right',
                            });
                            setStatusUpdate(!statsUpdate);
                        }
                    }).catch(error => {
                        console.log("deleteError", error);
                    });
                }
            });
        }
    }

    // Change Status functionality

    const ChangeStatus = (row, Num) => {
        if (tenderType === 'Category') {
            const formData = new FormData()
            formData.append("id", row)
            formData.append("status", Num)
            Swal.fire({
                customClass: 'swal-wide',
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#403fad',
                cancelButtonColor: '#f1388b',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.isConfirmed) {
                    ChangeAddOnCategoryStatus(formData).then(data => {
                        if (data.status === 200) {
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: 'success',
                                title: data.data.message,
                                showConfirmButton: false,
                                timer: 2000,
                                toast: true,
                                position: 'top-right',
                            })
                            setStatusUpdate(!statsUpdate)
                        }
                    }).catch(error => {
                        console.log("error===>",error)
                    })
                }
            })
        }
        if (tenderType === 'AddOns') {
            const formData = new FormData()
            formData.append("id", row)
            formData.append("status", Num)
            Swal.fire({
                customClass: 'swal-wide',
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#403fad',
                cancelButtonColor: '#f1388b',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.isConfirmed) {
                    ChangeStatusAddOn(formData).then(data => {
                        if (data.status === 200) {
                            Swal.fire({
                                customClass: 'swal-wide',
                                position: 'absolute',
                                icon: 'success',
                                title: data.data.message,
                                showConfirmButton: false,
                                timer: 2000,
                                toast: true,
                                position: 'top-right',
                            })
                            setStatusUpdate(!statsUpdate)
                        }
                    }).catch(error => {
                        console.log("error===>",error)
                    })
                }
            })
        }
    }

    const handleEdit = (id) => {
        navigate(`/company/menu/menu/add_ons/edit/${id}?pageno=${page}`);
    }
    const handleView = (id) => {
        navigate(`/company/menu/menu/add_ons/view/${id}?pageno=${page}`);
    }
    const copyOutletFunction = (id) => {
        navigate(`/company/menu/menu/add_ons/edit/${id}?copy=true&pageno=${page}`);
    }
    // edit functionality

    const editFunction = (row) => {
        setCatId(row)
        GetSingleAddOnCategory({ 'id': row }).then(data => {
            setShowDefault(data && data.data && data.data.response ? data.data.response : [])
            setOrderMode(data && data.data && data.data.response ? data.data.response.order_modes : []);
        }).catch(error => {
            console.log("error=====>", error)
        })
        setActionType('edit');
        $('#addCardModal').show().css('opacity', 1).addClass('show');
        $('body').append('<div class="modal-backdrop fade show"></div>')
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }
    // search or filer end



    // addMore 

    const tenderConfiguration = (value) => {
        setTenderType(value);
        let nameEn = name;

        if (value === 'AddOns') {
            nameEn = 'Name';
        } else if (value === 'Category') {
            nameEn = 'Name';
        }
        setName(nameEn);
    }


    const generateSKU = (length = 8) => {

        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let sku = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            sku += characters[randomIndex];
        }
        formik.setFieldValue("sku", sku);
    }

    const closeModel = (id) => {
        formik.setErrors({});
        formik.resetForm();
        $('#addCardModal').hide();
        $('.modal-backdrop').remove();
        setShowDefault({});
        setStatusUpdate(!statsUpdate)
    }

    const openModel = (id, type) => {
        formik.setErrors({});
        formik.resetForm();
        setActionType(type);
        $('#' + id).show().css('opacity', 1).addClass('show');
        $('body').append('<div class="modal-backdrop fade show"></div>')
        setOrderMode([]);
    }




    const validationSchema = yup.object().shape({
        name: yup.string().trim().required('Name is required').min(3, 'Name must be at least 3 characters').max(30, 'Name must be at most 30 characters'),
        name_ar: yup.string().trim().required('Name (arabic) is required').min(3, 'Name (arabic) must be at least 3 characters').max(30, 'Name (arabic) must be at most 30 characters'),
        sku: yup.string().required('Sku is required')
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: showDefault && showDefault.name ? showDefault.name : "",
            name_ar: showDefault && showDefault.name_ar ? showDefault.name_ar : "",
            sku: showDefault && showDefault.sku ? showDefault.sku : "",
            commission: showDefault && showDefault.commission ? showDefault.commission : "",
            orderMode: showDefault && showDefault.order_modes ? showDefault.order_modes : "",
            status: showDefault && showDefault.status == 1 ? 'on' : "",
            tax: showDefault && showDefault.tax ? showDefault.tax : ""
        },
        validationSchema: validationSchema,
        onSubmit: values => {

            setSubmitted(true)
            let formData = new FormData();
            formData.append('name', values?.name?.trim());
            formData.append('name_ar', values?.name_ar?.trim());
            formData.append('status', values.status == 'on' ? 1 : 0);
            formData.append('sku', values?.sku?.trim());
            formData.append('company_id', getCompany().company_id);
            formData.append('brand_id', getBrandId());
            if (actionType === 'edit') {
                const formData = new FormData()
                formData.append('name', values?.name?.trim());
                formData.append('name_ar', values?.name_ar?.trim());
                formData.append('sku', values?.sku?.trim());
                formData.append('id', catId);
                formData.append('brand_id', getBrandId());
                editAddOnCategory(formData).then(response => {


                    if (response.data.status === 1 || response.data.status === "1") {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500,
                            toast: true,
                            position: 'top-right',
                        });
                        setTimeout(() => {
                            $('#addCardModal').hide();
                            $('.modal-backdrop').remove();
                            setStatusUpdate(!statsUpdate)
                            formik.resetForm();
                            setShowDefault({});
                        }, 1000);
                    } else {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 5000,
                            toast: true,
                            position: 'top-right',
                        })
                        setSubmitted(false)
                    }
                }).catch(error => {
                    console.log("error ====> ", error);
                })

            } else {
                CreateAddOnCategory(formData).then(response => {
                    if (response.data.status === 1 || response.data.status === "1") {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500,
                            toast: true,
                            position: 'top-right',
                        });
                        setTimeout(() => {
                            $('#addCardModal').hide();
                            $('.modal-backdrop').remove();
                            setStatusUpdate(!statsUpdate)
                            formik.resetForm();
                            setShowDefault({});
                        }, 1000);
                    } else {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 5000,
                            toast: true,
                            position: 'top-right',
                        })
                        setSubmitted(false)
                    }
                }).catch(error => {
                    console.log("error ====> ", error);
                })

            }

        },
    });


    useEffect(() => {
        if (tenderType == 'AddOns') {
            setList([])
        }
    }, [tenderType])

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
    })


    return (
        <>
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Menu</h4>
                    </div>
                    <div className='page-header-right ms-auto'>

                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationTab tab='addOns' />
                            </div>
                        </div>
                    </div>
                    <div className='gap-20 ps-0 pb-0 pe-0'>
                        <ul className='d-flex setting submenu-list border-bottom mb-0 p-0'>
                            {checkPermission('store_menu_addons', 'view') ?
                                <li className={tenderType === 'AddOns' ? 'active' : ''} onClick={() => { tenderConfiguration('AddOns');setSorting({}) }}>Add-Ons Listing</li>
                                : ''}
                            {checkPermission('store_menu_addon_category', 'view') ?
                                <li className={tenderType === 'Category' ? 'active' : ''} onClick={() => { tenderConfiguration('Category');setSorting({}) }}>Categories</li>
                                : ''}
                        </ul>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex flex-wrap align-items-center mb-0' style={{ rowGap: '12px' }}>
                            <div className='page-header-left' style={{ flex: '1 1 auto', minWidth: 0 }}>
                                <div className='gap-2'>
                                    <div className='filter-header d-flex flex-wrap align-items-center' style={{ gap: '12px' }}>
                                        <div className="form-group mb-0 rangepicker_container">
                                            <input
                                                type="search"
                                                className="form-control"
                                                value={globalSearch}
                                                placeholder="Search"
                                                onChange={(e) => { setGlobalSearch(e.target.value) }}
                                            />
                                        </div>

                                        {tenderType === 'AddOns' &&
                                            <select
                                                className="form-control cp"
                                                value={search.category_id || ''}
                                                onChange={(e) => { prepareSearch('category_id', e.target.value) }}
                                                style={{ width: '180px' }}
                                            >
                                                <option value="">All Categories</option>
                                                {addOnCategories.map((category) => (
                                                    <option key={category.id} value={category.id}>{capitalizeFirstLetter(category.name)}</option>
                                                ))}
                                            </select>
                                        }

                                        <div style={{ width: '150px' }}>
                                            <StatusFilter
                                                data={showFilterlist}
                                                prepareSearch={prepareSearch}
                                                value={search.status === undefined ? '' : String(search.status)}
                                            />
                                        </div>
                                        {/* <div className="date-input">
                                            <CustomRangepicker
                                                GetDateRange={(e) => { prepareSearch("created", e) }}
                                                resetdate={resetdate}
                                            />
                                        </div> */}
                                        <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary">Reset Filter</button>
                                    </div>
                                </div>

                            </div>


                            <div className='page-header-right ms-auto d-flex align-items-center gap-2'>
                                <input type="file" accept=".csv,.xls,.xlsx" onChange={handleAddOnFileChange} ref={addOnFileInputRef} style={{ display: 'none' }} />
                                <input type="file" accept=".xls,.xlsx" onChange={handleAddOnRecipeFileChange} ref={recipeFileInputRef} style={{ display: 'none' }} />
                                <input type="file" accept=".xls,.xlsx" onChange={handleAddOnPricingFileChange} ref={pricingFileInputRef} style={{ display: 'none' }} />
                                {/* Spreadsheet actions for add-ons, grouped as on the menu items page */}
                                {tenderType === 'AddOns' ?
                                    <div className="dropdown">
                                        <button className="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Bulk Actions
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-end">
                                            <li><h6 className="dropdown-header">Add Ons</h6></li>
                                            <li>
                                                <div className="dropdown-item cp" onClick={triggerAddOnFileInput}>
                                                    <i className="ti ti-upload" aria-hidden="true"></i> {importing ? 'Importing...' : 'Import'}
                                                </div>
                                            </li>
                                            <li>
                                                <div className="dropdown-item cp" onClick={handleExport}>
                                                    <i className="ti ti-download" aria-hidden="true"></i> {exporting ? 'Exporting...' : 'Export'}
                                                </div>
                                            </li>
                                            <li><div className="dropdown-item cp" onClick={() => downloadAddOnSample('csv', 'csv')}><i className="ti ti-file" aria-hidden="true"></i> Sample csv file</div></li>
                                            <li><div className="dropdown-item cp" onClick={() => downloadAddOnSample('biff8', 'xls')}><i className="ti ti-file" aria-hidden="true"></i> Sample xls file</div></li>
                                            <li><div className="dropdown-item cp" onClick={() => downloadAddOnSample('xlsx', 'xlsx')}><i className="ti ti-file" aria-hidden="true"></i> Sample xlsx file</div></li>
                                            <li><hr className="dropdown-divider" /></li>
                                            <li><h6 className="dropdown-header">Recipes</h6></li>
                                            <li><div className="dropdown-item cp" onClick={triggerRecipeFileInput}><i className="ti ti-upload" aria-hidden="true"></i> {importingRecipes ? 'Importing...' : 'Import'}</div></li>
                                            <li><div className="dropdown-item cp" onClick={downloadAddOnRecipes}><i className="ti ti-file" aria-hidden="true"></i> {exportingRecipes ? 'Preparing...' : 'Export sample file'}</div></li>
                                            <li><hr className="dropdown-divider" /></li>
                                            <li><h6 className="dropdown-header">Pricing</h6></li>
                                            <li><div className="dropdown-item cp" onClick={triggerPricingFileInput}><i className="ti ti-upload" aria-hidden="true"></i> {importingPricing ? 'Importing...' : 'Import'}</div></li>
                                            <li><div className="dropdown-item cp" onClick={downloadAddOnsPricing}><i className="ti ti-file" aria-hidden="true"></i> {exportingPricing ? 'Preparing...' : 'Export sample file'}</div></li>
                                        </ul>
                                    </div> : null}
                                {/* <button className="btn btn-primary btn-lg" type="button" onClick={(e) => {
                                    if (tenderType === 'AddOns') {
                                        navigate(`/company/menu/menu/add_ons/add`);
                                    } else {
                                        openModel('addCardModal', 'add');
                                    }
                                }}>
                                    {tenderType === "AddOns" ? 'Create Add Ons' : 'Create an Add-On Category'}
                                </button> */}
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={(e) => {
                                        if (tenderType === 'AddOns' && checkPermission('store_menu_addons', 'add')) {
                                            navigate(`/company/menu/menu/add_ons/add`);
                                        } else if (tenderType !== 'AddOns' && checkPermission('store_menu_addon_category', 'add')) {
                                            openModel('addCardModal', 'add');
                                        }
                                    }}
                                >
                                    {tenderType === "AddOns" ? 'Create Add Ons' : 'Create an Add-On Category'}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='d-inline-flex align-items-start'>
                                                <span>Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="id" />
                                            </div>
                                        </th>
                                        {/* <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Sr. No  </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th> */}
                                        <th width="20%">
                                            <div className='sorting_column'>
                                                <span>{name}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name" />
                                            </div>
                                        </th>
                                        <th width="20%">
                                            <div className='sorting_column'>
                                                <span>{name + ' (arabic)'}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name_ar" />
                                            </div>
                                        </th>
                                        {/* <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Category </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="sku" />
                                            </div>
                                        </th> */}
                                        {tenderType === "Category" && (
                                            <>
                                                <th width="20%">
                                                    <div className='sorting_column'>
                                                        <span>SKU </span>
                                                    </div>
                                                </th>
                                                <th width="15%">
                                                    <div className='sorting_column'>
                                                        <span>Created Date</span>
                                                        <Sorting sort={sorting} handleSort={handleSort} column="created_at" />
                                                    </div>
                                                </th>
                                            </>)
                                        }
                                        {tenderType === "AddOns" && (
                                        //     <th width="19%">
                                        //     <span>Category  </span>
                                        // </th>
                                        <th width="20%">
                                            <div className='sorting_column'>
                                                <span>Category </span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="category" /> */}
                                            </div>
                                        </th>
                                    )}

                                        <th width="5%">
                                            <span>Status  </span>
                                        </th>
                                        {/* <th className='status_head text-center' width="10%">Status</th> */}
                                        <th className='action_head text-end' width="20%">Actions</th>


                                    </tr>
                                </thead>
                                {tenderType === 'AddOns' && <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={12}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr>
                                                    {/* <td>{i + 1}</td> */}
                                                    <td>{row.id}</td>
                                                    <td>{capitalizeFirstLetter(row?.name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.name_ar)}</td>

                                                    {/* <td>{capitalizeFirstLetter(row?.menu_add_on_category?.name)}</td> */}
                                                    {/* {
                                                        tenderType === "AddOns" && 
                                                        <td className='d-flex'>
                                                            {   
                                                                row?.menu_add_on_category_relations?.length
                                                                ? 
                                                                    row?.menu_add_on_category_relations?.map((relation, index) => {
                                                                        return <div className='show-data-single' style={{ }}>
                                                                            <div className='set-value'>{relation?.menu_add_on_category?.name}</div>
                                                                        </div>
                                                                        // return index == row?.menu_add_on_category_relations?.length -1 
                                                                        // ? relation?.menu_add_on_category?.name
                                                                        // : `${relation?.menu_add_on_category?.name}, `
                                                                    })
                                                                : null
                                                            }
                                                        </td>
                                                    }    */}
                                                    {
                                                        tenderType === "AddOns" && 
                                                        <td>
                                                            {   
                                                                row?.menu_add_on_category_relations?.length
                                                                ? 
                                                                    row?.menu_add_on_category_relations?.map(relation => capitalizeFirstLetter(relation?.menu_add_on_category?.name))
                                                                    .join(', ')
                                                                : '-'
                                                            }
                                                        </td>
                                                    }   

                                                    {/* <td>{moment(row?.created_at).format("DD-MM-YYYY")}</td> */}

                                                    <td>
                                                        <div className="form-check form-switch w-25 mx-auto">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" for="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                {checkPermission('store_menu_addons', 'view') ?
                                                                    <li><div className='dropdown-item' onClick={() => { handleView(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i>View</div></li>
                                                                    : ''}
                                                                {checkPermission('store_menu_addons', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { handleEdit(row.id) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                    : ''}
                                                                {checkPermission('store_menu_addons', 'delete') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                    : ''}
                                                                {checkPermission('store_menu_addons', 'add') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row.id) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy add-ons</div></li>
                                                                    : ''}

                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>}
                                {tenderType === 'Category' && <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={11}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr>
                                                    <td>{row?.id}</td>
                                                    <td>{row?.name}</td>
                                                    <td>{row?.name_ar}</td>

                                                    <td>{row?.sku}</td>
                                                    <td>{moment(row?.created_at).format("DD-MM-YYYY")}</td>

                                                    <td>
                                                        <div className="form-check form-switch w-25 mx-auto">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" for="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                {checkPermission('store_menu_addon_category', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { editFunction(row.id) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                    : ''}
                                                                {checkPermission('store_menu_addon_category', 'delete') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                    : ''}

                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr><td colSpan={11} className="text-center">No records</td></tr>}</>}
                                </tbody>}
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div className="" id="example1_info" role="status" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "add-on", path: "/company/menu/menu/add_ons/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>

                {/*  Modal*/}
                <div className="modal fade" id="addCardModal" aria-labelledby="addCardModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title lg" style={{ fontSize: '15px' }} id="addCardModalLabel">{actionType === 'edit' ? 'Edit' : 'Add'} {name}</h5>
                                <button type="button" className="btn-close" onClick={(e) => closeModel('addCardModal')} data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label for="name" className="col-form-label">{name}:<span className="requirestar">*</span></label>
                                        <input type="text" className="form-control" id="name" name="name" placeholder={'Enter ' + name} onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name} autoComplete='off' />
                                        <span className='text-danger d-flex text-left'>{formik.errors.name && formik.touched.name && formik.errors.name}</span>
                                    </div>
                                    <div className="mb-3">
                                        <label for="name_ar" className="col-form-label">{name + ' (arabic)'}:<span className="requirestar">*</span></label>
                                        <input type="text" className="form-control" name="name_ar" id="name_ar" placeholder={'Enter ' + name} onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name_ar} autoComplete='off' />
                                        <span className='text-danger d-flex text-left'>{formik.errors.name_ar && formik.touched.name_ar && formik.errors.name_ar}</span>
                                    </div>
                                    <div className="mb-3">
                                        <label for="sku" className="col-form-label">SKU:<span className="requirestar">*</span></label>
                                        <div className="set-plus-icon-input">
                                            <input type="text" name="sku" className="form-control" id="sku" placeholder='Enter SKU' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.sku} autoComplete='off' />
                                            <div className="icon-box">
                                                <a onClick={(e) => generateSKU(8)}><i className="fa fa-rotate-right"></i></a>
                                            </div>
                                        </div>
                                        <span className='text-danger d-flex text-left'>{formik.errors.sku && formik.touched.sku && formik.errors.sku}</span>
                                    </div>



                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-outline-dark" style={{ width: '48%' }} data-bs-dismiss="modal" onClick={(e) => closeModel('addCardModal')}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" style={{ width: '48%' }}>{actionType === 'edit' ? 'Update' : 'Add'}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>
        </>
    );
}

export default AddOnsList